<style lang="less" scoped>
.margim-t-10 {
  margin-bottom: 10px;
}

.status-dialog-body {
  padding: 8px 0;

  .status-dialog-model {
    padding: 12px 16px;
    margin-bottom: 20px;
    background: #f5f7fa;
    border-radius: 8px;
    font-size: 14px;
    color: #606266;

    .model-label {
      color: #909399;
      margin-right: 8px;
    }

    .model-value {
      font-weight: 500;
      color: #303133;
    }
  }

  .status-radio-group {
    display: flex;
    gap: 22px;
    margin-top: 8px;
    margin-left: 10px;
    justify-content: flex-start;

    .el-radio {
      display: block;
      margin: 22px 0;
      height: auto;
      line-height: 1.5;
    }
  }
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">车辆型号管理</div>
      <!-- <div class="page-title-div">电站管理</div> -->
      <ZD-list-querys> </ZD-list-querys>
      <div class="page-action-btns flex margim-t-10">
        <button class="common-bg-button" @click="listAddFun()">新 增</button>
        <button class="common-bg-button" @click="listEditFun()">编 辑</button>
        <div class="flex-1"></div>
        <el-input size="small" style="width:320px;margin-right:10px;" class="list-serach-input"
          v-model="queryInfo.vehicleModel" clearable placeholder="请输入车辆型号"></el-input>
        <button class="common-bg-button" @click="getListData(pagination, true)">搜索</button>
      </div>
      <!-- 表格 -->
      <div class="list-table">
        <ZD-table :tableColumns="tableColumns" :operates="operates" :tableData="tableData"
          :tableConfig="pageConfig.tableConfig" :selections="selections"
          v-on:updateSelections="(sels) => { selections = sels }"></ZD-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData"></ZD-pagination>
      </div>
    </div>

    <el-dialog title="设置状态" :visible.sync="statusDialogVisible" width="420px" @close="closeStatusDialog"
      class="status-dialog">
      <div v-if="statusDialogRow" class="status-dialog-body">
        <div class="status-dialog-model">
          <span class="model-label">车辆型号:</span>
          <span class="model-value">{{ statusDialogRow.vehicleBrand }} {{ statusDialogRow.vehicleModel }}</span>
        </div>
        <el-radio-group v-model="statusDialogInvokeFlag" class="status-radio-group">
          <el-radio label="Y">启用</el-radio>
          <el-radio label="N">停用</el-radio>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeStatusDialog">取 消</el-button>
        <el-button type="primary" @click="submitStatusDialog">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import pageConfig from './page-config'
export default {
  computed: {
    tableColumns() {
      const cols = [...this.pageConfig.listColumns]
      return cols.map((c) => {
        if (c.props === 'invokeFlag') {
          return { ...c, cellClick: (row) => this.openStatusDialog(row) }
        }
        return c
      })
    },
  },
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      tableData: [], // 表格数据
      selections: [], // 表格选项
      pagination: pageConfig.pagination,
      queryInfo: {},
      operates: { width: 0, fixed: 'right', list: [] }, // 无操作列，状态列直接点击操作
      statusDialogVisible: false,
      statusDialogRow: null,
      statusDialogInvokeFlag: 'Y',
    }
  },
  methods: {
    init() {
      this.getListData(this.pagination, true)
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this
      _.$U.showLoading(_)
      _.queryInfo.pageNum = pagination.current - 1
      if (reload) {
        this.pagination.current = 1
        _.queryInfo.pageNum = 0
      }
      _.queryInfo.pageSize = pagination.pageSize
      _.queryInfo.corpNo = _.$store.state.corpNo
      _.$H.post(_, _.$A.digitization.vehicleModel, _.queryInfo).then((res) => {
        _.tableData = res.data.data.content || []
        _.pagination.total = res.data.data.totalElements || 0
        _.$U.hideLoading(_)
      })
    },
    // 页面新增方法
    listAddFun() {
      let _ = this;
      _.$store.commit('setEditId', '')
      this.$S.listAddFun(this, pageConfig.tableEditObj)
    },
    checkSelectOne() {
      if (this.selections.length < 1) {
        this.$U.error('请选择需要操作的对象');
        return false;
      }
      if (this.selections.length > 1) {
        this.$U.error('只能选择一个操作的对象');
        return false;
      }
      return true;
    },
    // 页面编辑方法
    listEditFun() {
      let _ = this;
      if (this.checkSelectOne()) {
        _.$store.commit('setEditId', _.selections[0].modelId)
        _.$router.push({
          name: 'VehicleModelDetail',
          query: {
            modelInfo: this.selections[0]
          }
        })
      }
    },
    // 列表直接启用/停用，传参与编辑接口一致
    openStatusDialog(row) {
      this.statusDialogRow = row
      this.statusDialogInvokeFlag = row.invokeFlag === 'N' ? 'N' : 'Y'
      this.statusDialogVisible = true
    },
    closeStatusDialog() {
      this.statusDialogVisible = false
      this.statusDialogRow = null
      this.statusDialogInvokeFlag = 'Y'
    },
    submitStatusDialog() {
      const _ = this
      if (!_.statusDialogRow) return
      _.$U.showLoading(_)
      const params = { ..._.statusDialogRow, invokeFlag: _.statusDialogInvokeFlag, corpNo: _.$store.state.corpNo }
      _.$H.post(_, _.$A.digitization.vehicleModelEdit, params).then((res) => {
        _.$U.hideLoading(_)
        if (res.status === 200) {
          _.$message.success('操作成功')
          _.closeStatusDialog()
          _.getListData(_.pagination, false)
        } else {
          _.$message.error(res?.data?.message || res?.data?.msg || '操作失败')
        }
      }).catch(() => {
        _.$U.hideLoading(_)
        _.$message.error('操作失败')
      })
    },
  },
  mounted() {
    this.init()
  },
}
</script>
